/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateTempoVerificationKeyInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateTempoVerificationKeyMutationVariables = {
    input: CreateTempoVerificationKeyInput;
};
export type CreateTempoVerificationKeyMutationResponse = {
    readonly createTempoVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type CreateTempoVerificationKeyMutation = {
    readonly response: CreateTempoVerificationKeyMutationResponse;
    readonly variables: CreateTempoVerificationKeyMutationVariables;
};



/*
mutation CreateTempoVerificationKeyMutation(
  $input: CreateTempoVerificationKeyInput!
) {
  createTempoVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateTempoVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTempoVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createTempoVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTempoVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTempoVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateTempoVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTempoVerificationKeyMutation(\n  $input: CreateTempoVerificationKeyInput!\n) {\n  createTempoVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = '427d4ebc8081e459beec71a0032a4f16';
export default node;
